import React from 'react';
import { motion } from 'framer-motion';
export function StickyAlertBar() {
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-espresso-900 text-cream-100 py-2 px-4 shadow-md" data-id="element-161">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center text-sm md:text-base text-center gap-2" data-id="element-162">
        <span className="flex items-center gap-2" data-id="element-163">
          <span className="animate-pulse" data-id="element-164">🔥</span>
          <span className="font-medium" data-id="element-165">Oferta especial:</span>
          <span className="line-through opacity-75" data-id="element-166">Antes $30</span>
          <span className="text-gold-500 font-bold" data-id="element-167">→ Hoy $13.97</span>
        </span>
        <span className="hidden sm:inline opacity-50" data-id="element-168">|</span>
        <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="font-bold underline decoration-gold-500 underline-offset-4 hover:text-gold-500 transition-colors" data-id="element-169">
          ¡Solo por HOY!
        </a>
      </div>
    </motion.div>;
}